import React, { useCallback, useEffect, useState } from 'react';
import { NavigationButtons } from './TspNavigation';
import './TspLayoutStyles.css';


export default function TspLayout({ 
  showPanel, 
  setShowPanel, 
  goToHome,
  sidebar,
  map
}) {
  // Toggle sidebar show/hide
  const togglePanel = useCallback(() => {
    setShowPanel(prev => !prev);
  }, [setShowPanel]);
  
  // State to track sidebar width for responsive layout
  const [sidebarWidth, setSidebarWidth] = useState('350px');
  
  // Effect to handle sidebar width changes
  useEffect(() => {
    // Check if sidebar is visible
    if (!showPanel) return;
    
    // Listen for sidebar width changes
    const checkSidebarWidth = () => {
      const sidebarElement = document.querySelector('.tsp-sidebar-container');
      if (sidebarElement) {
        const width = sidebarElement.style.width || '350px';
        if (width !== sidebarWidth) {
          setSidebarWidth(width);
        }
      }
    };
    
    // Initial check
    checkSidebarWidth();
    
    // Watch for changes
    const observer = new MutationObserver(checkSidebarWidth);
    const sidebarElement = document.querySelector('.tsp-sidebar-container');
    
    if (sidebarElement) {
      observer.observe(sidebarElement, { 
        attributes: true, 
        attributeFilter: ['style'] 
      });
    }
    
    // Load from localStorage on mount
    const savedWidth = localStorage.getItem('tspSidebarWidth');
    if (savedWidth) {
      setSidebarWidth(savedWidth);
    }
    
    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [showPanel, sidebarWidth]);

  return (
    <div className="tsp-layout">
      {/* Sidebar */}
      {showPanel && sidebar}
      
      {/* Main content area (map) */}
      <div 
        className={`tsp-main ${showPanel ? 'with-sidebar' : 'full-width'}`}
        style={showPanel ? { width: `calc(100% - ${sidebarWidth})` } : undefined}
      >
        {/* Navigation buttons */}
        <NavigationButtons 
          goToHome={goToHome}
          showPanel={showPanel}
          togglePanel={togglePanel}
        />
        
        {/* Map component */}
        {map}
      </div>
    </div>
  );
} 